import React from 'react';

/**
 * Badge — small status pill. Tones cover Yapp's roles & states:
 * brand, success, warning, danger, premium (gold), anonymous, neutral.
 */
export function Badge({
  tone = 'brand',
  icon = null,
  children,
  style = {},
  ...rest
}) {
  const tones = {
    brand:     { bg: 'var(--brand-100)',  fg: 'var(--brand-700)' },
    success:   { bg: 'rgba(76,175,80,0.16)', fg: '#2e7d32' },
    warning:   { bg: 'rgba(255,152,0,0.18)', fg: '#b25e00' },
    danger:    { bg: 'rgba(244,67,54,0.14)', fg: 'var(--danger-500)' },
    premium:   { bg: 'linear-gradient(135deg,#ffd700,#ffb700)', fg: '#5c4500' },
    anonymous: { bg: 'rgba(156,39,176,0.16)', fg: '#7b1fa2' },
    neutral:   { bg: 'var(--neutral-100)', fg: 'var(--neutral-600)' },
  };
  const t = tones[tone] || tones.brand;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.3rem',
        padding: '0.2rem 0.55rem',
        background: t.bg,
        color: t.fg,
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-2xs)',
        fontWeight: 'var(--weight-bold)',
        textTransform: 'uppercase',
        letterSpacing: 'var(--tracking-wide)',
        borderRadius: 'var(--radius-pill)',
        lineHeight: 1.4,
        ...style,
      }}
      {...rest}
    >
      {icon}
      {children}
    </span>
  );
}
